import React from 'react';
import {
  Button, BUTTON_TYPES, ComponentWrapper, Card, BasicInputRow, ADDRESS_BOOKS, ComponentVerticalSpacing
} from 'day8-react/build/new-components';
import CustomInputRow from 'day8-react/build/new-components/Form/CustomInputRow';
import PropTypes from 'prop-types';

const formFields = [
  {
    name: 'firstName',
    type: 'text',
    placeholder: 'Name',
    label: 'Name',
    labelHidden: true,
    defaultValue: ''
  },
  {
    name: 'where',
    type: 'select',
    placeholder: 'Where shall we go in 2026?',
    label: 'Where shall we go in 2026?',
    labelHidden: true,
    options: [
      'Home to Obertauern',
      'Stateside',
      'Japan',
      'Chamonix'
    ],
    defaultValue: ''
  },
  {
    name: 'email',
    type: 'email',
    placeholder: 'Enter email',
    label: 'Email',
    labelHidden: true,
    defaultValue: ''
  }
];

const SignUpYear = ({ year, addressBookId }) => (
  <ComponentVerticalSpacing>
    <ComponentWrapper>
      <h1 className="text-center margin-bottom-md max-width-xxxxs margin-auto position-relative">
        Sign up for {year}
      </h1>
      <div className="max-width-sm margin-auto">
        <div className="margin-bottom-sm">
          <CustomInputRow
            postTo="/api/marketing/add-contact"
            extraBodyProps={{ addressBookId: addressBookId || ADDRESS_BOOKS['tsw-signup-2025'] }}
            successMessage="You're signed up!"
            subscribeButtonText="Sign up now"
            fields={formFields}
          />
        </div>
        <div className="text-component d8-u-color-black text-center padding-bottom-xl position-relative">
          <p>This year, we&apos;re taking a break, ready to come back stronger than ever in 2026. Our promise to you is always an epic adventure filled with slope-side spectacles, breathtaking backdrops and a global community like no other. We want to take you with us. Sign up to be in the know first as we reach for new peaks in the following year.</p>
        </div>
        <Card
          template="ImageCard"
          size="aspect-16-9"
          imageCardTemplate="Horizontal"
          video="https://www.youtube.com/embed/Dc_T4-86H68"
          bgImage={{
            url: 'https://assets.theskiweek.com/wp-content/uploads/2020/07/parade-austria.jpg',
            alt: 'Woman skiiing'
          }}
          overlay
        />
      </div>
    </ComponentWrapper>
  </ComponentVerticalSpacing>
);

SignUpYear.propTypes = {
  year: PropTypes.string,
  addressBookId: PropTypes.string
};

export default SignUpYear;
